module.exports = __webpack_public_path__ + "img/line.24213116.svg";